import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = {
  key: 1,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\">Please Note!</h4><div class=\"fs-6 text-gray-600\"><p align=\"justify\">You have pending PPS for setup. To avoid PPS not getting points please setup the position of your PPS now before using pending points.</p></div></div></div>", 1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "From User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Points"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Date Encoded"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Action")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        (_ctx.pt !== 'ovi')
          ? (_openBlock(), _createBlock(_component_ECP_EDP_DashboardNavigator, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.isShowPackagePointsWarning)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
              ]),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("table", _hoisted_8, [
            _hoisted_9,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                  _createVNode("td", null, _toDisplayString(item.usid), 1),
                  _createVNode("td", null, _toDisplayString(item.fullname), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(item.bp).toFixed(2))), 1),
                  _createVNode("td", null, _toDisplayString(item.dtestp), 1),
                  (item.sts === 'READY')
                    ? (_openBlock(), _createBlock("td", _hoisted_10, [
                        (_ctx.isSending === false)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1",
                              onClick: ($event: any) => (_ctx.usePackagePoints(item.recid))
                            }, " Use Points ", 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_11, _toDisplayString(item.sts), 1))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}